import { NavLink, useMatch, useResolvedPath, Link } from "react-router-dom";
import trustedLogo from "../assets/images/trustedLogo.svg";
import { useState, useEffect } from "react";

function Header() {
	const [isOpen, setIsOpen] = useState(false);
	const [isScrolled, setIsScrolled] = useState(false);

	const toggleMenu = () => {
		setIsOpen((open) => !open);
	};

	const closeMenu = () => {
		setIsOpen(false);
	};

	const scrollToTop = () => {
		window.scrollTo(0, 0);
	};

	useEffect(() => {
		if (isOpen) {
			document.body.classList.add("no-scroll");
		} else {
			document.body.classList.remove("no-scroll");
		}
	}, [isOpen]);

	useEffect(() => {
		const handleScroll = () => {
			setIsScrolled(window.scrollY > 0);
		};

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		<header className={`${isOpen ? "" : isScrolled ? "scrolled" : ""}`}>
			<nav className={`navBar mobileWidth ${isOpen ? "isOpen" : ""}`}>
				<div className="mobileHeaderOnly">
					<NavLink
						className="link logo headerLogo"
						to="/"
						onClick={() => {
							closeMenu();
							scrollToTop();
						}}
					>
						<img alt="GCAS Regina" src={trustedLogo} />
					</NavLink>
					<button
						aria-label="Toggle Menu for Navigation"
						className={`hamburger ${isOpen ? "isOpen" : ""}`}
						onClick={toggleMenu}
					>
						<i className="fa-solid fa-bars-staggered"></i>
					</button>
				</div>

				<div className={`navItems ${isOpen ? "isOpen" : ""}`}>
					<div className="navItem">
						<CustomLink
							to="/"
							onClick={() => {
								closeMenu();
								scrollToTop();
							}}
						>
							Home
						</CustomLink>
						<CustomLink
							to="/services"
							onClick={() => {
								closeMenu();
								scrollToTop();
							}}
						>
							Services
						</CustomLink>
						<CustomLink
							to="/about"
							onClick={() => {
								closeMenu();
								scrollToTop();
							}}
						>
							About Us
						</CustomLink>

						<CustomLink
							to="/contact"
							onClick={() => {
								closeMenu();
								scrollToTop();
							}}
						>
							Contact
						</CustomLink>
					</div>

					<Link
						to="/contact"
						aria-label="Book an Appointment"
						className={`cta navBtn ${isOpen ? "isOpen" : ""}`}
						// target="_blank"
						// rel="noopener noreferrer"
						onClick={scrollToTop}
					>
						Book an Appointment
					</Link>
				</div>
			</nav>
		</header>
	);
}

function CustomLink({ to, children, onClick, ...props }) {
	const resolvedPath = useResolvedPath(to);
	const isActive = useMatch({ path: resolvedPath.pathname, end: true });

	return (
		<div className={isActive ? "active" : ""}>
			<NavLink className="navItem" to={to} onClick={onClick} {...props}>
				{children}
			</NavLink>
		</div>
	);
}

export default Header;
